import apiService from 'src/shared/config/apiService';
import { RFQ } from 'src/shared/types/rfq';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export const getProductDrafts = async () => {
  try {
    const response = await apiService.get<RFQ[]>('/rfqs?published=false');

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
